<template>
	<div id="app">
		<div
			style="position: fixed;top: 0; z-index: 999; background-color: red;width: 100%;height: 15px;line-height: 15px; text-align: center;font-size: 12px;color: white;font-weight: 600;">
			推荐使用谷歌双核浏览器</div>
		<!-- 客服 首页头部 -->
		<div>
			<div id="rightArrow" @click="moveLeftOrRight"
				:class="moveFlag?moveLeftRight==='left' ? 'animationLeftExpose':'animationRightExpose':''"
				:style="moveFlag?moveLeftRight==='left' ? 'background-position: 0 0;':'background-position: -50px 0;':''">
				<a :class="moveFlag?moveLeftRight==='left' ? 'animationLeftMove':'animationLeftMove':''"></a>
				<div class="arrowtxt">在线客服</div>
			</div>
			<!-- 左部客服弹出框 -->
			<div id="floatDivBoxs" :class="moveFlag?moveLeftRight==='left' ? 'animationLeft':'animationRight':''">
				<div class="floatDtt">在线客服</div>
				<div class="floatShadow">
					<ul class="floatDqq">
						<li>
							<a target="_blank" style="color: black;"
								:href="'https://wpa.qq.com/msgrd?v=3&amp;uin='+QQnumberOne+'&amp;site=qq&amp;menu=yes'"><span>在线咨询</span></a>
						</li>
						<li>
							<a target="_blank" style="color: black;"
								:href="'https://wpa.qq.com/msgrd?v=3&amp;uin='+QQnumberTwo+'&amp;site=qq&amp;menu=yes'"><span>在线咨询</span></a>
						</li>
						<li>
							<a target="_blank" style="color: black;"
								:href="'https://wpa.qq.com/msgrd?v=3&amp;uin='+QQnumberThree+'&amp;site=qq&amp;menu=yes'"><span>在线咨询</span></a>
						</li>
					</ul>
					<div class="floatDtxt">服务热线</div>
					<ul class="floatDtel">
						<li><span class="icoTl">17310535369</span></li>
					</ul>
				</div>
				<div class="floatDbg"></div>
			</div>
			<!-- 页面头部 -->
			<div class=""
				style="height: 70px;position: fixed;z-index: 999;top:15px;right: 0;width: 100%;border: 0;left: 0;background-color: #fff;">
				<div>
					<ul class="nav	w-1200" style="width: 1295px;margin: 0 auto;">
						<a href="/internetplusIndex" style="position: absolute;font-weight: bold;font-size: 30px;color:black;">
							<!-- <img style="width:60px;height: 60px;line-height: 70px;" src="../../../static/img/logo.png"> -->
							互联网+技能提升培训与学习
						</a>
						<!-- 公众号/登录/注册 -->
						<div style="position: absolute;right: 60px;">
							<li class="m" style="margin-left: 10px;">
								<a @mouseover="gzhMouseOver" @mouseleave="gzhMouseLeave"
									style="font-size: 17px;color:black;" class="layui-tel" href="javascript:;">
									<i class="layui-icon layui-icon-cellphone"></i>
									公众号
								</a>
								<div v-if="gzhFlag" class="hover_wrap"
									style="opacity:1;border-radius: 10px; top:75px;position: absolute; left: -70px; z-index: 999;background: #fff;border: 1px solid #ebeef5;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);width: 220px;height: 240px;">
									<div>
										<div class="arrr f-pa"></div>
										<div style="text-align: center;width: 100%;height: 20px;margin-top: 10px;">微信扫一扫
										</div>
										<div style="width: 180px;height: 180px;margin: 0 auto">
											<img src="../../../static/img/gongzhong.jpg" style="width: 100%;height: 100%;">
										</div>
									</div>
								</div>
							</li>
							<li class="m" style="margin-left: 30px;">
								<el-dropdown @command="loginHandleCommand"
									v-if="this.$storage.get('declareUser') == undefined">
									<a href="javascript:;" style="font-size: 17px;color:black;">
										<i class="layui-icon layui-icon-username"></i>
										登录<i class="el-icon-arrow-down el-icon--right"></i>
									</a>
									<el-dropdown-menu>
										<el-dropdown-item command="a">个人登录</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>

								<el-dropdown @command="loginHandleCommand1"
									v-if="this.$storage.get('declareUser') != undefined">
									<a href="javascript:;" style="font-size: 17px;color:black;">
										<i class="layui-icon layui-icon-username"></i>
										{{this.$storage.get('declareUser').userName}}<i
											class="el-icon-arrow-down el-icon--right"></i>
									</a>
									<el-dropdown-menu>
										<!-- <el-dropdown-item command="a" style="text-align: center;">个人信息
										</el-dropdown-item> -->
										<el-dropdown-item command="b" style="text-align: center;">退出</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</li>
							<li v-if="this.$storage.get('declareUser') == null && this.$storage.get('declareUser') == undefined"
								class="m" style="margin-left: 30px;">
								<el-dropdown @command="registerHandleCommand">
									<a href="javascript:;" class="login" style="font-size: 17px;color:black;">
										<i class="layui-icon layui-icon-username"></i>
										注册<i class="el-icon-arrow-down el-icon--right"></i>
									</a>
									<el-dropdown-menu>
										<el-dropdown-item command="a">个人注册</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</li>
						</div>
					</ul>
				</div>
			</div>
		</div>
		<!-- 页面导航栏 -->
		<div class="" style="background-color: #049be2;position: fixed;top:85px;z-index: 10;width: 100%;">
			<ul class="nav	w-1200" style="display: flex;justify-content:flex-start;;width: 1340px;">
				<!-- 导航栏 -->
				<li v-for="(item,index) in NavigationLists" :key="index" :class="item.state == 1? 'm':'m on'"
					@click="navigationSwitchover(index)">
					<h3>
						<router-link :to="item.url" class="nav-f">{{item.name}}</router-link>
					</h3>
				</li>
				<li class="m">
					<h3><a v-on:click="navigation(7)" id="kaoshi" class="nav-f">技能培训</a></h3>
				</li>
			</ul>
		</div>
		<router-view :key="$route.params.navId" style="margin-top: 20px;"></router-view>
		<div v-loading.fullscreen.lock="fullscreenLoading"></div>
		<end></end>
		<el-backtop>
		</el-backtop>
	</div>
</template>
<script>
	//import homePage from './components/homePage.vue';
	import End from '../end.vue';
	export default {
		name: 'app',
		components: {
			End
		},
		data() {
			return {
				fullscreenLoading: false,
				NavigationLists: [
					{
						state: 2,
						url: '/net',
						name: '首页'
					},
					{
						state: 1,
						url: '/journalismNoticenet/2',
						name: '政策文件'

					},
					{
						state: 1,
						url: '/journalismNoticenet/3',
						name: '实时新闻'
					},
					{
						state: 1,
						url: '/journalismNoticenet/6',
						name: '职业标准'
					}],
				gzhFlag: false,
				navigationName: '',
				flag: 0,
				drawer: false,
				moveFlag: false,
				moveLeftRight: '',
				declareUser: {},
				slideshowVo: {},
				x: 50,
				y: 50,
				xin: true,
				yin: true,
				step: 1,
				delay: 10,
				itl: null,
				showAdbox: true,
			}
		},
		created() {
			//默认加载 通知公告
			this.HandoverNotificationOrPresscenterDataLoad(29);
		},
		watch: {
			'$route': function (to, from) {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			}
		},
		methods: {
			HandoverNotificationOrPresscenterDataLoad(navId) {
				//加载 首页 数据  
				let parames = new URLSearchParams();
				parames.append('navId', navId); //id 类型id 
				parames.append('organStatus', this.organStatus);//  组织机构代码   1工大  2协会 3建投

				this.$axios.post(this.serverUrl + '/navList', parames).then(resp => {

					if (resp.data.data.length > 0) {

						resp.data.data.forEach((element, index) => {


							//轮播图 最多三条
							if (index < 1) {
								let slideshowVo = {
									id: 0,
									navName: 0,
									src: '',
									contentTitle: '',
									insertTime: ''
								}

								slideshowVo.id = element.id;
								slideshowVo.navName = element.navName;
								slideshowVo.contentTitle = element.contentTitle;

								this.slideshowVo = slideshowVo;

							}
						})

					}
				}).catch(err => {
					this.$message({
						showClose: true,
						message: '服务器繁忙,请稍后再试!',
						type: 'error'
					})
				})
			},
			detail() {
				this.$router.push({ path: '/journalismNoticeDetailnet/' + this.slideshowVo.id + "/" + this.slideshowVo.navName })
			},
			navigationSwitchover(index) {
				this.NavigationLists.forEach(element => {
					if (element.state == 2) {
						element.state = 1;
					}
				});
				this.NavigationLists[index].state = 2;
			},
			//注册
			registerHandleCommand(command) {
				if (command === 'a') {
					this.$router.push('/personRegisternet')
				}
			},
			//登录
			loginHandleCommand(command) {
				if (command === 'a') {
					this.$router.push('/loginnet')
				} else {
					// 使用动态获取的管理员登录URL
					window.location.href = this.adminLoginUrl;
				}
			},
			//登录后
			loginHandleCommand1(command) {
				if (command === 'a') {
					this.$router.push({ path: '/personalInformation/5/1' })
				}
				if (command === 'b') {

					let parames = new URLSearchParams();
					parames.append('userId', this.$storage.get("declareUser").id);
					this.$axios.post(this.serverUrl + '/logout', parames).then(resp => {

						//个人
						console.log('清除前的token==========' + this.$storage.get('token'));
						console.log('清除前的declareUser==========' + this.$storage.get('declareUser'));
						//退出登录
						this.$storage.remove('token');
						this.$storage.remove('declareUser');
						this.$storage.remove('one_pa');
						console.log('清除完后的token==========' + this.$storage.get('token'));
						console.log('清除完后的declareUser==========' + this.$storage.get('declareUser'));


						this.$router.push('/loginnet');

					}).catch(err => {

					})


				}
			},
			key() {
				return new Date().getTime;
			},
			//客服左移右移
			moveLeftOrRight() {
				//this.drawer=true;
				if (this.moveLeftRight === '') {
					this.moveLeftRight = 'left';
				} else if (this.moveLeftRight === 'left') {
					this.moveLeftRight = 'right';
				} else {
					this.moveLeftRight = 'left';
				}
				this.moveFlag = true;//开启动画
			},
			//导航方法
			navigation(data) {
				if (data === 7) {
					if (this.$storage.get("declareUser") === undefined) {
						this.$confirm('请先登录！').then(_ => {
							this.$router.push('/login');
						}).catch(_ => { });
					} else {
						//技能培训
						this.$router.push({ path: '/train' });
					}
				} 
				
				/* else if (data === 8) {
					if (this.$storage.get("declareUser") === undefined) {
						this.$confirm('请先登录！').then(_ => {
							this.$router.push('/login');
						}).catch(_ => { });
					} else {
						this.fullscreenLoading = true;
						//技能考试
						let parames = new URLSearchParams();
						parames.append('userId', this.$storage.get("declareUser").id);
						let ArrayList = [];
						this.$axios.post(this.serverUrl + '/ex/examList', parames).then(resp => {
							//能进来此接口就一定有考试信息 直接循环获取
							if (resp.data.data.length > 0) {

								this.fullscreenLoading = false;
								//技能考试
								this.$router.push({ path: '/examHomePage' });

							} else {
								this.fullscreenLoading = false;
								this.$message({
									showClose: true,
									message: '暂无考试！',
									type: 'warning',
									offset: 300,
									center: true

								})
							}
						}).catch(err => {

						})
					}
				} */
			},
			//公众号鼠标移入
			gzhMouseOver() {
				console.log("鼠标移入");
				this.gzhFlag = true;
			},
			//公众号鼠标移出
			gzhMouseLeave() {
				console.log("鼠标移出");
				this.gzhFlag = false;
			},
		}
	}
</script>

<style scoped>
	#floatDivBoxs {
		width: 120px;
		background: #fff;
		position: fixed;
		top: 180px;
		right: -125px;
		z-index: 999;
	}

	#floatDivBoxs .floatDqq li {
		height: 45px;
		line-height: 45px;
		font-size: 15px;
		border-bottom: 1px solid #e3e3e3;
		padding: 0 0 0 36px;
		background: url(../../../static/img/qq.gif) no-repeat left center;
	}

	#adbox {
		width: 500px;
		height: auto;
		background-color: #7ac5ff;
		position: absolute;
		z-index: 999;
		color: white;
		padding: 20px;
		font-size: 15px;

	}

	#adbox img {
		border: none;
	}

	#adbox b {
		position: absolute;
		right: 5px;
		top: 0;
		cursor: pointer;
		color: #666;
	}

















	.floatDbg {
		width: 120px;
		height: 20px;
		background: url(../../../static/f/img/online_botbg.jpg) no-repeat;
	}

	.floatDtt {
		width: 120px;
		height: 45px;
		line-height: 45px;
		background: #00aeef;
		color: #fff;
		font-size: 18px;
		text-indent: 22px;
		position: relative;
	}

	#rightArrow {
		right: 120px;
		width: 50px;
		height: 145px;
		background: url(../../../static/f/img/online_arrow.jpg) no-repeat;
		position: fixed;
		top: 180px;
		right: -5px;
		z-index: 9999;

	}

	#floatDivBoxs {
		right: 0px;
		width: 120px;
		background: #fff;
		position: fixed;
		top: 180px;
		right: -125px;
		z-index: 999;
	}


	.animationLeftMove {
		animation: rotation 0.5s linear;
	}

	@keyframes rotation {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(180deg);
		}
	}

	.animationLeftExpose {
		animation: moveLeftExpose 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}

	.animationRightExpose {
		animation: moveRightExpose 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;

	}

	@keyframes moveLeftExpose {
		from {
			right: 0px;
		}

		to {
			right: 120px;
		}
	}

	@keyframes moveRightExpose {
		from {
			right: 120px;
		}

		to {
			right: 0px;
		}
	}

	.animationLeft {
		animation: moveLeft 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}

	.animationRight {
		animation: moveRight 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}

	@keyframes moveLeft {
		from {
			right: -120px;
		}

		to {
			right: 0px;
		}
	}

	@keyframes moveRight {
		from {
			right: 0px;
		}

		to {
			right: -120px;
		}
	}

	.a {
		position: absolute;
		left: 0;
		top: 65px;
		min-width: 100%;
		line-height: 36px;
		padding: 5px 0;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
		border: 1px solid #d2d2d2;
		background-color: #fff;
		z-index: 100;
		border-radius: 2px;
		white-space: nowrap;
	}

	.bd {
		margin: 0 auto;
		width: 100% !important;
		position: relative;
		z-index: 0;
	}

	.mian {
		min-width: 1200px;
		padding-top: 15px;
	}

	.page_box {
		width: 100%;
		height: auto;
		overflow: hidden;
		margin: 0 auto;
		clear: both;
	}

	.page_box_right {
		width: 1200px;
		height: auto;
		overflow: hidden;
		margin: 0 auto;
	}

	#fitslist {
		padding: 0 15px;
		min-height: 400px;
	}

	#fitslist .index_6_2_1_4 {
		width: 100%;
		height: 110px;
		padding-bottom: 25px;
		border-bottom: #eeeeee solid 1px;
		margin-top: 15px;
		float: left;
	}

	#fitslist .index_6_2_1_4_2 {
		width: 980px;
		height: 110px;
		padding: 0 15px;
		float: left;
		line-height: 110px;
	}

	.clearfix {
		display: block;
		clear: both;
	}
</style>


// WEBPACK FOOTER //
// src/components/internetplus/index.vue